export var Locale;
(function (Locale) {
    Locale["ZhHans"] = "zh-Hans";
    Locale["Zh"] = "zh";
    Locale["ZhCn"] = "zh-CN";
    Locale["ZhSg"] = "zh-SG";
    Locale["ZhHant"] = "zh-Hant";
    Locale["ZhNk"] = "zh-HK";
    Locale["ZhMo"] = "zh-MO";
    Locale["ZhTw"] = "zh-TW";
    Locale["En"] = "en";
    Locale["EnAs"] = "en-AS";
    Locale["EnAi"] = "en-AI";
    Locale["EnAg"] = "en-AG";
    Locale["EnAu"] = "en-AU";
    Locale["EnAt"] = "en-AT";
    Locale["EnBs"] = "en-BS";
    Locale["EnBb"] = "en-BB";
    Locale["EnBe"] = "en-BE";
    Locale["EnBz"] = "en-BZ";
    Locale["EnBm"] = "en-BM";
    Locale["EnBw"] = "en-BW";
    Locale["EnIo"] = "en-IO";
    Locale["EnVg"] = "en-VG";
    Locale["EnBi"] = "en-BI";
    Locale["EnCm"] = "en-CM";
    Locale["EnCa"] = "en-CA";
    Locale["En029"] = "en-029";
    Locale["EnKy"] = "en-KY";
    Locale["EnCx"] = "en-CX";
    Locale["EnCc"] = "en-CC";
    Locale["EnCk"] = "en-CK";
    Locale["EnCy"] = "en-CY";
    Locale["EnDk"] = "en-DK";
    Locale["EnDm"] = "en-DM";
    Locale["EnEr"] = "en-ER";
    Locale["En150"] = "en-150";
    Locale["EnFk"] = "en-FK";
    Locale["EnFi"] = "en-FI";
    Locale["EnFj"] = "en-FJ";
    Locale["EnGm"] = "en-GM";
    Locale["EnDe"] = "en-DE";
    Locale["EnGh"] = "en-GH";
    Locale["EnGi"] = "en-GI";
    Locale["EnGd"] = "en-GD";
    Locale["EnGu"] = "en-GU";
    Locale["EnGg"] = "en-GG";
    Locale["EnGy"] = "en-GY";
    Locale["EnHk"] = "en-HK";
    Locale["EnIn"] = "en-IN";
    Locale["EnIe"] = "en-IE";
    Locale["EnIm"] = "en-IM";
    Locale["EnIl"] = "en-IL";
    Locale["EnJm"] = "en-JM";
    Locale["EnJe"] = "en-JE";
    Locale["EnKe"] = "en-KE";
    Locale["EnKi"] = "en-KI";
    Locale["EnLs"] = "en-LS";
    Locale["EnLr"] = "en-LR";
    Locale["EnMo"] = "en-MO";
    Locale["EnMg"] = "en-MG";
    Locale["EnMw"] = "en-MW";
    Locale["EnMy"] = "en-MY";
    Locale["EnMt"] = "en-MT";
    Locale["EnMh"] = "en-MH";
    Locale["EnMu"] = "en-MU";
    Locale["EnFm"] = "en-FM";
    Locale["EnMs"] = "en-MS";
    Locale["EnNa"] = "en-NA";
    Locale["EnNr"] = "en-NR";
    Locale["EnNl"] = "en-NL";
    Locale["EnNz"] = "en-NZ";
    Locale["EnNg"] = "en-NG";
    Locale["EnNu"] = "en-NU";
    Locale["EnNf"] = "en-NF";
    Locale["EnMp"] = "en-MP";
    Locale["EnPk"] = "en-PK";
    Locale["EnPw"] = "en-PW";
    Locale["EnPg"] = "en-PG";
    Locale["EnPn"] = "en-PN";
    Locale["EnPr"] = "en-PR";
    Locale["EnPh"] = "en-PH";
    Locale["EnRw"] = "en-RW";
    Locale["EnKn"] = "en-KN";
    Locale["EnLc"] = "en-LC";
    Locale["EnVc"] = "en-VC";
    Locale["EnWs"] = "en-WS";
    Locale["EnSc"] = "en-SC";
    Locale["EnSl"] = "en-SL";
    Locale["EnSg"] = "en-SG";
    Locale["EnSx"] = "en-SX";
    Locale["EnSi"] = "en-SI";
    Locale["EnSb"] = "en-SB";
    Locale["EnZa"] = "en-ZA";
    Locale["EnSs"] = "en-SS";
    Locale["EnSh"] = "en-SH";
    Locale["EnSd"] = "en-SD";
    Locale["EnSz"] = "en-SZ";
    Locale["EnSe"] = "en-SE";
    Locale["EnCh"] = "en-CH";
    Locale["EnTz"] = "en-TZ";
    Locale["EnTk"] = "en-TK";
    Locale["EnTo"] = "en-TO";
    Locale["EnTt"] = "en-TT";
    Locale["EnTc"] = "en-TC";
    Locale["EnTv"] = "en-TV";
    Locale["EnUg"] = "en-UG";
    Locale["EnAe"] = "en-AE";
    Locale["EnGb"] = "en-GB";
    Locale["EnUs"] = "en-US";
    Locale["EnUm"] = "en-UM";
    Locale["EnVi"] = "en-VI";
    Locale["EnVu"] = "en-VU";
    Locale["En001"] = "en-001";
    Locale["EnZm"] = "en-ZM";
    Locale["EnZw"] = "en-ZW";
    Locale["Ru"] = "ru";
    Locale["RuBy"] = "ru-BY";
    Locale["RuKz"] = "ru-KZ";
    Locale["RuKg"] = "ru-KG";
    Locale["RuMd"] = "ru-MD";
    Locale["RuRu"] = "ru-RU";
    Locale["RuUa"] = "ru-UA";
    Locale["Tr"] = "tr";
    Locale["TrCy"] = "tr-CY";
    Locale["TrTr"] = "tr-TR";
    Locale["Ka"] = "ka";
    Locale["KaGe"] = "ka-GE";
    Locale["Ko"] = "ko";
    Locale["KoKr"] = "ko-KR";
    Locale["KoKp"] = "ko-KP";
})(Locale || (Locale = {}));
